import OfflineManagementCurrentStatus from './currentStatus'
import RealNetworkStatus from './realNetwork'

import './styles.scss'

export default function OfflineManagement() {
  return (
    <div className='offline-management'>
      <RealNetworkStatus />
      <OfflineManagementCurrentStatus />
    </div>
  )
}
